import { render } from "./select-themes-categories.vue?vue&type=template&id=7f9b5086"
import script from "./select-themes-categories.vue?vue&type=script&lang=js"
export * from "./select-themes-categories.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\sander\\IdeaProjects\\matchmaking\\fbm-matchmaking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__